import { Customer } from '@shopware-pwa/types';
import { getCustomer } from '@shopware-pwa/api-client';

export function useCustomer() {
  const { apiInstance } = useShopwareContext();

  const getCustomerByToken = async (
    contextToken: string | null | undefined,
  ): Promise<Customer | null> => {
    if (!contextToken) {
      return null;
    }

    apiInstance.update({ contextToken });
    return await getCustomer({}, apiInstance);
  };

  return {
    getCustomerByToken,
  };
}
